export default "__VITE_ASSET__CP2Y1jhm__"